<script>
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";

export default {
    components: {
        Layout,
        PageHeader
    },
    data() {
        return {
            data: {},
        };
    },
    mounted() {
        var vm = this;

        vm.load();
    },
    watch: {
        $route() {
            var vm = this;

            vm.load();
        }
    },
    methods: {
        load() {
            var vm = this;

            if (vm.$route.params.id) {
                vm.create();
            } else {
                vm.newData();

                if (vm.$route.query.branch_id)
                    vm.data.branch_id = vm.$route.query.branch_id;
            }
        },
        newData() {
            var vm = this;

            var data = {
                id: null,
                branch_id: null,
                status_id: null,
                user_id: null,
                sender_user_id: null,
                email: null,
            };

            vm.data = Object.assign({}, data);
        },
        async create() {
            var vm = this;

            this.$loading.on('employee_detail_create');
            try {
                vm.newData();

                var resp = await this.$api.Employee.get(vm.$route.params.id);
                var data = resp.data.data;

                vm.data = data;

                this.$loading.off('employee_detail_create');
            } catch (err) {
                this.$flash.error(err.response.data.message);
            }
        },
        async submit() {
            var vm = this;
            this.$loading.on('employee_detail_submit');

            try {
                var postData = vm._createPostData(vm.data);
                var resp = await this.$api.Employee.create(postData);

                var data = resp.data;

                if (vm.$route.params.id) {
                    vm.create();
                } else {
                    vm.$router.push({ name: 'employee-detail', params: { id: data.data } });
                }

                this.$flash.success(data.message);
            } catch (err) {
                this.$flash.error(err.response.data.message);
            }
            this.$loading.off('employee_detail_submit');
        },
        _createPostData(data) {

            return data;
        },
        async email() {
            var vm = this;
            this.$loading.on('employee_detail_email_submit');

            try {
                var params = {
                    id: vm.data.id
                };

                var resp = await this.$api.Employee.email(params);

                var data = resp.data;
                vm.create();

                this.$flash.success(data.message);
            } catch (err) {
                this.$flash.error(err.response.data.message);
            }
            this.$loading.off('employee_detail_email_submit');
        },
        fetchBranch: async function (params) {
            const resp = await this.$api.Branch.all(params)

            const data = resp.data.data

            const list = data.map(row => ({
                id: row.id,
                text: row.text,
                model: row,
            }))

            const meta = resp.data.meta

            return {
                options: list,
                more: meta.current_page < meta.last_page
            }
        },
        fetchStatus: async function (params) {
            var newParams = {
                ...params,
                group_by: 'employee_status'
            };

            const resp = await this.$api.Category.all(newParams)

            const data = resp.data.data

            const list = data.map(row => ({
                id: row.id,
                text: row.text,
                model: row,
            }))

            const meta = resp.data.meta

            return {
                options: list,
                more: meta.current_page < meta.last_page
            }
        },
        fetchUser: async function (params) {
            const resp = await this.$api.User.all(params)

            const data = resp.data.data

            const list = data.map(row => ({
                id: row.id,
                text: row.text,
                model: row,
            }))

            const meta = resp.data.meta

            return {
                options: list,
                more: meta.current_page < meta.last_page
            }
        }
    }
};
</script>

<template>
    <Layout>
        <PageHeader :title="$t('employee.title.form')" :pageTitle="$t('menu.sub_header.dashboard')" />

        <BRow class="justify-content-center">
            <BCol lg="8">
                <b-form @submit="submit()">
                    <BCard no-body>
                        <BCardBody>
                            <loading :loading="$loading.get('employee_detail_create')" variant="dark" type="block">
                                <BRow>
                                    <BCol class="mb-3" lg="12">
                                        <label for="choices-publish-status-input" class="form-label">{{
                                            $t('employee.label.branch')
                                            }}</label>
                                        <dynamic-select v-model="data.branch_id"
                                            :placeholder="$t('employee.placeholder.branch')"
                                            :loadOptions="fetchBranch" />
                                    </BCol>
                                    <BCol class="mb-3" lg="12">
                                        <label for="choices-publish-status-input" class="form-label">{{
                                            $t('employee.label.sender')
                                            }}</label>
                                        <dynamic-select v-model="data.sender_user_id"
                                            :placeholder="$t('employee.placeholder.sender')" :loadOptions="fetchUser" />
                                    </BCol>
                                    <BCol class="mb-3" lg="12">
                                        <label for="choices-publish-status-input" class="form-label">{{
                                            $t('employee.label.user')
                                            }}</label>
                                        <dynamic-select v-model="data.user_id"
                                            :placeholder="$t('employee.placeholder.user')" :loadOptions="fetchUser" />
                                    </BCol>
                                    <BCol class="mb-3" lg="12">
                                        <label for="choices-publish-status-input" class="form-label">{{
                                            $t('employee.label.status')
                                            }}</label>
                                        <dynamic-select v-model="data.status_id"
                                            :placeholder="$t('employee.placeholder.status')" :loadOptions="fetchStatus" />
                                    </BCol>
                                </BRow>
                            </loading>
                        </BCardBody>
                        <BCardFooter v-if="$ac.hasAccess('employee_full_access')">
                            <div class="hstack gap-2 justify-content-end">
                                <div class="hstack gap-2">
                                    <BButton variant="info" type="button"
                                        v-if="data.id && $ac.hasAccess('employee_full_access')" @click="email"
                                        :disabled="$loading.get('employee_detail_email_submit')">
                                        <loading :loading="$loading.get('employee_detail_email_submit')" variant="light"
                                            type="button">
                                            <i class="mdi mdi-email-outline me-1"></i>
                                            {{ $t('employee.btn.email') }}
                                        </loading>
                                    </BButton>
                                    <BButton type="submit" variant="success" class="w-sm"
                                        v-if="($ac.hasAccess('employee_full_access'))"
                                        :disabled="$loading.get('employee_detail_submit')">
                                        <loading :loading="$loading.get('employee_detail_submit')" variant="light"
                                            type="button">
                                            <i class="mdi mdi-floppy me-1"></i>
                                            {{ $t('basic.btn.save') }}
                                        </loading>
                                    </BButton>
                                </div>
                            </div>
                        </BCardFooter>
                    </BCard>
                </b-form>
            </BCol>
        </BRow>
    </Layout>
</template>